import { createFileRoute } from '@tanstack/react-router';

import { InvoiceDetailPage } from '@/pages/invoicing/InvoiceDetailPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/invoicing/$invoiceId')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['invoicing.read.own', 'invoicing.read.all'], redirectTo: '/dashboard' }),
	component: InvoiceDetailPage,
});
